import type { GradingProvider } from './types'

/** CGC's internal grade 11 renders as "10P" (Pristine) */
export function formatGrade(grade: number | string, provider: GradingProvider): string {
  const n = typeof grade === 'string' ? Number(grade) : grade
  if (provider === 'CGC' && n === 11) return '10P'
  return String(n)
}

/** 0.502 → "50.2" */
export function formatCenteringValue(ratio: number | null | undefined): string {
  return ((ratio ?? 0.5) * 100).toFixed(1)
}

/** (0.502, 0.498) → "50.2% / 49.8%" */
export function formatCenteringPair(a?: number | null, b?: number | null): string {
  return `${formatCenteringValue(a)}% / ${formatCenteringValue(b)}%`
}

export function formatMoney(
  value: number | null | undefined,
  { signed = false, zeroAsDash = false }: { signed?: boolean; zeroAsDash?: boolean } = {},
): string {
  if (value == null || Number.isNaN(value)) return zeroAsDash ? '—' : '$0'
  const abs = Math.abs(value)
  const rounded = Math.round(abs)
  const body = `$${rounded.toLocaleString('en-US')}`
  if (signed && value < 0) return `-${body}`
  return body
}

/** ISO date → "May 19, 2026" */
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  })
}

/** Confidence 0–1 → whole percent number, e.g. 0.85 → 85 */
export function toPercent(p: number): number {
  return Math.round(p * 100)
}

/** "an 85%" but "a 60%" */
export function percentArticle(percent: number): string {
  return /^(8|11|18)/.test(String(percent)) ? 'an' : 'a'
}
